import TagManager from 'react-gtm-module';

import { getTagManagerArgs } from './googleTagManagerArgs';

export const pushMenuEventGTM = (eventLabel: string) => {
  TagManager.dataLayer(getTagManagerArgs({ event: 'menu_clicked', label: eventLabel }));
};
